import styled from 'styled-components';

export const NestedComponentContainer = styled.div`
  padding: var(--cl-space-3) var(--cl-space-3) var(--cl-space-3) var(--cl-space-6);
  background: var(--cl-gray-200);

  & > *:first-child {
    margin-top: 0px !important;
  }
`;
